import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerGiornaliSchedeMagazzinoModalComponent } from './worker-giornali-schede-magazzino-modal';

export const WorkerGiornaliSchedeMagazzinoModalModule: string = ng
    .module('worker-giornali-schede-magazzino-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerGiornaliSchedeMagazzinoModalComponent', WorkerGiornaliSchedeMagazzinoModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-giornali-schede-magazzino-modal/worker-giornali-schede-magazzino-modal.module.ts